<div class="d-flex protection">
  @for (option of options; let idx = $index; track option) {
    <options-list
      class="protection-item"
      (click)="selectProtection.emit(option.value)"
      [options]="option.options"
    >
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <ds-radio [selected]="value === option.value" class="mr-2 radio-indicator" />
          <p class="protection-title">{{ option.title }}</p>
        </div>
        @if (option.value || !idx) {
          <p>{{ option.pricePerPerson | portalCurrency }}/traveler</p>
        }
      </div>
    </options-list>
  }
</div>
